import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";
import { ToWords } from "to-words";

function EditInvoice({ item_id, order_id, onClose, onInvoiceEdited }) {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const { setGlobalLoading, token } = useOutletContext();
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
  const [currency, setCurrencies] = useState([]);
  const [data, setData] = useState([]);
  const [invoices, setinvoices] = useState([]);
  const [finalINRAmount, setFinalINRAmount] = useState(0);
  const retainerAmount = watch("retainer_amount");
  const finalRetainer = Number(watch("final_retainer") || 0);
  const expenseOption = Number(watch("has_expense") || 0);
  const expenseAmount = watch("expense_amount");
  const conversionAmount = watch("conversion_rate");
  const billableAmount = watch("billable_compensation");
  const totalCompensation = watch("total_compensation");
  const [candidate_id, setCandidateId] = useState(0);
  const [retainerSplits, setRetainerSplits] = useState([]);
  const [totalFees, setTotalFees] = useState(0);
  const [totalRetainer, setTotalRetainer] = useState(0);
  const isSubmitDisabled = !finalINRAmount || Number(finalINRAmount.toString().replace(/,/g, "")) === 0; 
  
  const totalCompensationInINR = Math.round(totalCompensation * conversionAmount);
  const billableCompensationInINR = Math.round(billableAmount * conversionAmount);

  const getOrderDetails = async () => {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/orders/invoice_detail/${item_id}/${order_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      let str = response.data.order_detail.retainer_splits;
      const splits = str
        .split(",")
        .map((v) => v.replace("%", ""))
        .map((v) => Number(v))
        .filter((v) => v !== 0);
      setData(response.data.order_detail);
      setinvoices(response.data.invoices || []);
      setValue("id", response.data.order_detail.id);
      setValue("invoice_id", response.data.order_detail.invoice_id);
      setValue("role_id", response.data.order_detail.role_id);
      setValue("company_id", response.data.order_detail.company_id);
      setValue("currency_id", response.data.order_detail.currency_id);
      setValue("name", response.data.order_detail.name);
      setValue("reporting_date", response.data.order_detail.reporting_date);
      setValue("raised_date", response.data.order_detail.raised_date);
      setValue("final_retainer", response.data.order_detail.final_retainer);
      setValue("has_expense", response.data.order_detail.has_expense);
      setValue("expense_amount", response.data.order_detail.expense_amount);
      setValue("candidate_name", response.data.order_detail.candidate_name);
      setValue("candidate_id", response.data.order_detail.candidate_id);
      setValue("fee_percentage", response.data.order_detail.fee_percentage);
      setValue("total_fees", response.data.order_detail.total_fees);
      setValue("billable_compensation", response.data.order_detail.billable_compensation);
      setValue("total_compensation", response.data.order_detail.total_compensation);
      setValue("retainer_amount", response.data.order_detail.retainer_amount);
      setValue("old_amount", response.data.order_detail.amount);
      setValue("old_conversion_rate", response.data.order_detail.conversion_rate);
      setValue("amount", response.data.order_detail.amount);
      setValue("conversion_rate", response.data.order_detail.conversion_rate);
      setValue("comments", response.data.order_detail.comments);
      setValue("entity_id", response.data.order_detail.entity_id);
      setCandidateId(response.data.order_detail.candidate_id || 0);

    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const getCurrency = async () => {
    try {
      //   setGlobalLoading(true);
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/orders/get_currencies`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setCurrencies(response.data.options || []);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      await getCurrency(); // wait for currencies
      await getOrderDetails(); // then set values
    };

    init();
  }, [item_id]);

  function format_currency(num) {
    const isFloat = !Number.isInteger(num);
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: isFloat ? 0 : 0, // show 2 decimals only if float
      maximumFractionDigits: isFloat ? 0 : 0,
    }).format(num);
  }

  // const getConversation = async (name) => {
  //   try {
  //     const response = await axios.get(
  //       `https://api.currconv.com/api/v7/convert?q=${name}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`,
  //     );
  //     const rate = response.data;
  //     console.log(rate);
  //     const [currency, value] = Object.entries(rate)[0];
  //     const roundedValue = value ? Number(value.toFixed(3)) : 1;
  //     setValue("conversion_rate", roundedValue || 1);
  //   } catch (error) {
  //     console.log(error);
  //     setGlobalLoading(false);
  //   } finally {
  //     setGlobalLoading(false);
  //   }
  // };

    const getConversation = async (name) => {
    if (!name) {
      console.warn("Currency name missing");
      return;
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/currency-conversion`,
        {
          params: {
            currency: name,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const rate = Number(response.data?.rate);

      if (!rate || rate <= 0) {
        throw new Error(`Invalid conversion rate returned for ${name}: ${response.data?.rate}`);
      }

      const roundedValue = Number(rate.toFixed(3));
      console.log("Currency conversion:", {currency: name, rate: roundedValue});
      setValue("conversion_rate", roundedValue, {shouldDirty: false, shouldValidate: false});
    } catch (error) {
      console.error(
        `Currency conversion failed for ${name}:`,
        error
      );

      setValue("conversion_rate", null);
    }
  };

  const handleCurrencyChange = (e) => {
    const selectedCurrencyId = parseInt(e.target.value);
    console.log(selectedCurrencyId);
    if (selectedCurrencyId) {
      const currencyVal = currency?.find(
        (c) => c.id === selectedCurrencyId,
      )?.name;
      getConversation(currencyVal);
    }
  };

  const calculateRemainingFee = (totalFees, invoices) => {
    const existing = invoices.reduce(
      (sum, inv) => sum + (Number(inv.retainer_amount) || 0),
      0,
    );
    return {
      remaining: Math.round(totalFees - existing),
      totalExisting: existing,
    };
  };

  const calculateTotalFeeFromPercentage = (billable, percent) => {
    return Math.round((Number(billable) * Number(percent)) / 100);
  };

  const toWords = new ToWords({
      localeCode: "en-IN",
      converterOptions: {
        currency: true,
        ignoreDecimal: true,
      },
    });

  useEffect(() => {
    const retainer = Number(retainerAmount) || 0;
    const expense = expenseOption === 1 ? Number(expenseAmount) || 0 : 0;

    const finalAmount = retainer + expense;

    // Show 2 decimals only if required
    const formattedAmount = Number.isInteger(finalAmount)
      ? finalAmount
      : Number(finalAmount.toFixed(2));

    setValue("amount", formattedAmount);

    const finalINR = finalAmount * conversionAmount;
    const formattedINR = Number.isInteger(finalINR)
      ? finalINR
      : Number(finalINR.toFixed(2));

    setFinalINRAmount(format_currency(formattedINR));
  }, [retainerAmount, expenseAmount, expenseOption, conversionAmount]);
  
  useEffect(() => {
    if (!data || finalRetainer === 0) return;
    const feePercent =
      parseFloat((data?.fee_percentage || "").toString().replace(/%/g, "")) ||
      0;
    const billable = Number(billableAmount || 0);
    const isPercentageFee = feePercent <= 100;
    const calculatedTotalFees =
      isPercentageFee && billable > 0
        ? Math.round((billable * feePercent) / 100)
        : Number(data.total_fees || 0);
    const totalFees = calculatedTotalFees;
    const count = invoices.length;
    const { remaining, totalExisting } = calculateRemainingFee(
      totalFees,
      invoices,
    );
    const total = invoices.reduce(
      (sum, inv) => sum + (Number(inv.retainer_amount) || 0),
      0,
    );
    const total_expense = invoices.reduce(
      (sum, inv) => sum + (Number(inv.expense_amount) || 0),
      0,
    );
    setTotalRetainer(total);
    setTotalFees(totalFees);
    // setValue("total_fees",totalFees);
    // setValue("fee_percentage",feePercent);
    let nextExpenseAmount = 0;
    let nextRetainerAmount = 0;
    // -------------------------------------------------
    // FINAL RETAINER LOGIC
    // -------------------------------------------------
    if (finalRetainer === 1) {
      if (isPercentageFee) {
        // Final retainer for percentage fee
        if (billable != 0) {
          const totalFeeCalc = calculateTotalFeeFromPercentage(
            billable,
            feePercent,
          );
          nextRetainerAmount = Math.round(totalFeeCalc - totalExisting);
          setTotalFees(totalFeeCalc);
        } else {
          nextRetainerAmount = remaining;
        }
      } else {
        // Final retainer for fixed fee
        nextRetainerAmount = remaining;
      }
    }
    // -------------------------------------------------
    // NORMAL (NON-FINAL) RETAINERS
    // -------------------------------------------------
    else {
      const nextSplitPercent = retainerSplits[count];
      const splitPercent = Number(nextSplitPercent);
        if (splitPercent === 33.33 || splitPercent === 33.3 || splitPercent === 33.34) {
          nextRetainerAmount = Math.round(totalFees / 3);
        } else if (splitPercent > 100) {
          nextRetainerAmount = splitPercent;
        } else {
          nextRetainerAmount = Math.round((totalFees * splitPercent) / 100);
        }
    }

    // -------------------------------------------------
    // AUTO EXPENSE CALCULATION
    // -------------------------------------------------
    if (expenseOption === 1) {
      const previousExpenses = total_expense || 0;
      let expPercent = parseFloat((data?.expensePercent || "").toString().replace("%", "")) || 0;
      if (finalRetainer === 1) {
        // FINAL RETAINER CASE
        if (isPercentageFee) {
          if(expPercent > 100){
              nextExpenseAmount = expPercent - previousExpenses;
            }
          else if (expPercent > 0 && expPercent < 100) {
            const generatedExpense = Math.round(
              ((Number(billable) * Number(feePercent)) / 100) *
                (expPercent / 100),
            );
            nextExpenseAmount = generatedExpense - previousExpenses;
          } else {
            nextExpenseAmount = 0;
          }
        } else {
          const fixedExpense = Math.round((totalFees * expPercent) / 100);
          nextExpenseAmount = Math.max(fixedExpense - previousExpenses, 0);
        }
      } else {
        // NOT FINAL RETAINER → Expense should not auto-fill
        const totalExpense = Math.round(
          (nextRetainerAmount * expPercent) / 100,
        );
        nextExpenseAmount = totalExpense;
      }
    }
    // Update Form
    setValue("retainer_amount", nextRetainerAmount);
    setValue("expense_amount", nextExpenseAmount);
    setValue("total_fees", totalFees);
    setValue("fee_percentage", feePercent);
  }, [
    invoices,
    data,
    candidate_id,
    finalRetainer,
    billableAmount,
    expenseOption,
  ]);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });
      if (data.file_name && data.file_name.length > 0) {
        formData.append("file_name", data.file_name[0]);
      }
      const response = await axios.post(
        `${API_BASE_URL}/orders/edit_invoice`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      //  console.log(response);
      toastr.success("Invoice updated successfully!");
      onInvoiceEdited();
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Edit Invoice</h4>
              <button
                onClick={() => onClose()}
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x"></i>
              </button>
            </div>
            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-4 col-sm-4">
                  <div className="mb-2">
                    <label className="form-label">Retainer Name *</label>
                    <input
                      type="text"
                      {...register("name", { required: "required" })}
                      className={`form-control ${errors.name && "is-invalid"}`}
                    />
                    <input type="hidden" {...register("role_id")} />
                    <input type="hidden" {...register("company_id")} />
                    <input type="hidden" {...register("invoice_id")} />
                    <input type="hidden" {...register("entity_id")} />
                    <input type="hidden" {...register("reporting_date")} />
                    <input type="hidden" {...register("old_amount")} />
                    <input type="hidden" {...register("old_conversion_rate")} />
                  </div>
                </div>
                {finalRetainer === 1 && (
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                      <label className="form-label">Final Retainer * </label>
                      <select
                        {...register("final_retainer")}
                        className="form-select"
                        disabled
                      >
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  </div>
                )}
                <div className="col-md-4 col-sm-4">
                  <div className="mb-2">
                    <label className="form-label">
                      Raised Date *{" "}
                      <span className="fs-10 ms-2">(Trigger & Reporting)</span>
                    </label>
                    <div className="input-icon position-relative w-100 me-2">
                      <input
                        {...register(`raised_date`, { required: "required" })}
                        type="date"
                        className={`datetimepicker form-control ${errors.raised_date && "is-invalid"}`}
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {candidate_id != 0 && finalRetainer === 1 ? (
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                      <label className="form-label">Candidate Name * </label>
                      <input
                        type="text"
                        {...register("candidate_name", {
                          required: "required",
                        })}
                        className={`form-control ${errors.cnadidate_name && "is-invalid"}`}
                        readOnly
                      />
                      <input type="hidden" {...register("candidate_id")} />
                      <input type="hidden" {...register("fee_percentage")} />
                      <input type="hidden" {...register("total_fees")} />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                      <label className="form-label">
                        Billable Compensation *{" "}
                      </label>
                      <input
                        type="text"
                        {...register("billable_compensation", {
                          required: "required",
                          onChange: (e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            value = value.replace(/(\..*)\./g, "$1");
                            e.target.value = value;
                            setValue("billable_compensation", value, {
                              shouldValidate: true,
                            });
                          },
                        })}
                        className={`form-control ${errors.billable_compensation && "is-invalid"}`}
                      />
                      <br />
                      <span className="fs-10 ms-2">
                        {Number(billableCompensationInINR) > 0
                          ? toWords.convert(Number(billableCompensationInINR))
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="mb-2">
                      <label className="form-label">
                        Total Compensation *{" "}
                      </label>
                      <input
                        type="text"
                        {...register("total_compensation", {
                          required: "required",
                          onChange: (e) => {
                            let cleaned = e.target.value.replace(
                              /[^0-9.]/g,
                              "",
                            );
                            cleaned = cleaned.replace(/(\..*)\./g, "$1");
                            e.target.value = cleaned;
                            return cleaned;
                          },
                        })}
                        className={`form-control ${errors.total_compensation && "is-invalid"}`}
                      />
                      <br />
                      <span className="fs-10 ms-2">
                        {Number(totalCompensationInINR) > 0
                          ? toWords.convert(Number(totalCompensationInINR))
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="row">
                <div className="col-md-3 col-sm-3">
                  <div className="mb-2">
                    <label className="form-label">Retainer Amount * </label>
                    <input
                      type="text"
                      {...register("retainer_amount", { required: "required" })}
                      className={`form-control ${errors.retainer_amount && "is-invalid"}`}
                    />
                  </div>
                </div>
                <div className="col-md-2 col-sm-2">
                  <div className="mb-2">
                    <label className="form-label"> </label>
                    <select
                      {...register("currency_id", {
                        required: true,
                        onChange: (e) => handleCurrencyChange(e),
                      })}
                      className="form-select"
                      // disabled
                    >
                      <option value={""}>Select Currency</option>
                      {currency?.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.symbol} - {m.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3">
                  <div className="mb-2">
                    <label className="form-label">Expense * </label>
                    <select
                      {...register("has_expense")}
                      className="form-select"
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4">
                  {expenseOption === 1 ? (
                    <div className="mb-2">
                      <label className="form-label">Expense Amount</label>
                      <input
                        type="text"
                        {...register("expense_amount", {
                          required: "required",
                        })}
                        className={`form-control ${errors.expense_amount && "is-invalid"}`}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-md-12 col-sm-12">
                <div className="mb-2">
                  <span className="fs-12 ms-2">
                    (Expense Percent: {data?.expensePercent})
                  </span>
                </div>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="mb-2">
                  <label className="form-label">Final Amount * </label>
                  <input
                    type="text"
                    {...register("amount")}
                    className={`form-control ${errors.amount && "is-invalid"}`}
                    readOnly
                  />
                  <input type="hidden" {...register("conversion_rate")} />
                </div>
              </div>
              <div className="col-md-6 col-sm-6">
                <div className="mb-2">
                  <label className="form-label">Comments</label>
                  <input
                    type="text"
                    {...register("comments")}
                    className={`form-control ${errors.comments && "is-invalid"}`}
                  />
                </div>
              </div>
              <div className="col-md-12 col-sm-12">
                <div className="mb-2">
                  <span className="fs-12 ms-2">
                    (Revenue in INR: {finalINRAmount})
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {isSubmitDisabled && (
                <div className="text-danger mt-1 small">
                  Please wait for the currency conversion to complete.
                </div>
              )}
              <button type="submit" className="btn btn-primary ms-2" 
              disabled={!finalINRAmount || Number(finalINRAmount.toString().replace(/,/g, "")) === 0}>
                Update
              </button>
              <button
                onClick={onClose}
                type="button"
                className="btn btn-secondary ms-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default EditInvoice;
